import React from 'react';
import ServicePage from './ServicePage';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import ServerSetupImage from "../assets/server-setup.webp"
import styled from 'styled-components';

// Styled component for responsive process cards
const ProcessCard = styled.div`
  flex: 0 0 29%;
  margin-bottom: 30px;
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  flex-grow: 1;

  @media (max-width: 992px) {
    flex: 0 0 44%;
  }
  
  @media (max-width: 768px) {
    flex: 0 0 40%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 88%;
  }
`;

const ServerSetupPage = () => {
  const features = [
    'Expert configuration of physical and virtual servers',
    'Secure server hardening and protection implementation',
    'Performance optimization for maximum efficiency',
    'Comprehensive documentation and knowledge transfer',
    'Scalable architecture design for future growth',
    '24/7 monitoring and support options'
  ];

  const additionalContent = (
    <div>
      <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333', textAlign: 'center' }}>
        Our Server Setup Process
      </h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginTop: '40px' }}>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>01</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Requirements Analysis</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We thoroughly analyze your business needs to determine the optimal server configuration.</p>
        </ProcessCard>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>02</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Architecture Design</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>Our experts design a server architecture that aligns with your performance and scalability requirements.</p>
        </ProcessCard>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>03</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Implementation</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We handle the complete setup process, including hardware configuration, OS installation, and network setup.</p>
        </ProcessCard>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>04</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Security Hardening</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We implement robust security measures to protect your server from potential threats and vulnerabilities.</p>
        </ProcessCard>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>05</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Testing & Optimization</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We thoroughly test all server components and optimize performance for your specific workloads.</p>
        </ProcessCard>
        <ProcessCard>
          <div style={{ fontSize: '24px', fontWeight: '700', color: '#ff6e6e', marginBottom: '10px' }}>06</div>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>Documentation & Training</h4>
          <p style={{ fontSize: '14px', color: '#666' }}>We provide comprehensive documentation and training to ensure your team can effectively manage the server.</p>
        </ProcessCard>
      </div>
    </div>
  );

  return (
    <ServicePage
      icon={faServer}
      title="Server Setup"
      subtitle="Professional server configuration and deployment services to ensure optimal performance, security, and reliability for your business operations."
      description={["At ZeniTech Solutions, our Server Setup service is designed to provide complete, end-to-end solutions for businesses of all sizes and industries. From helping you choose the right hardware to full configuration, security hardening, and performance optimization, we take care of every detail to ensure your servers are up and running with maximum efficiency and minimal downtime.",

"We go beyond just basic setups — we leverage multiple leading server platforms like Google Cloud, AWS, and Microsoft Azure to offer you the best in scalability, flexibility, and innovation. Additionally, we proudly maintain our own private servers strategically located in India, Germany, and Singapore, giving us the unique ability to offer tailor-made hosting solutions based on your specific needs, budget, and target audience.",

"Whether you require high availability, lightning-fast speeds, or enhanced data protection, our expert team will help you select, deploy, and manage the ideal server environment to power your business success. With us, you’re not just getting a service — you’re getting a long-term technology partner committed to your growth and performance.",

"Experience the difference with a server setup that’s truly built around your goals, your security, and your future."]}
      features={features}
      imagePath={ServerSetupImage}
      additionalContent={additionalContent}
      featuresDesciption="At Zenitech Solutions, we deliver comprehensive server setup solutions customized to fit your unique business needs. Our team of seasoned experts is dedicated to providing top-quality service, with meticulous attention to every detail, ensuring your server infrastructure is secure, efficient, and built for success."
      metaTitle="Server Setup Services"
      metaDescription="Our Server Setup services provide comprehensive solutions for businesses of all sizes and industries. From hardware selection to configuration, security hardening, and performance optimization, we take care of every aspect to ensure your servers are up and running with maximum efficiency and minimal downtime."
    />
  );
};

export default ServerSetupPage;